import { faTrash } from '@fortawesome/pro-regular-svg-icons/faTrash';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Menu } from 'antd';
import { MenuItemProps } from 'antd/lib/menu/MenuItem';
import { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import { withHideIfNotAllowed } from 'components/organisms/permission-controller';

const MenuItem = styled(Menu.Item)`
  &:hover {
    background-color: var(--red-10);
    color: var(--red-60);
  }
  span {
    flex: 1;
  }
`;

const BaseDelete: FC<React.PropsWithChildren<MenuItemProps>> = (params) => {
  const {
    danger = true,
    icon = <FontAwesomeIcon icon={faTrash} />,
    children,
  } = params;

  return (
    <MenuItem danger={danger} icon={icon} {...params}>
      {children || <FormattedMessage id="delete" />}
    </MenuItem>
  );
};

export const Delete = withHideIfNotAllowed(BaseDelete);
